import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as incomeActions from '../../actions/incomeTestActions';
import * as propertyActions from '../../actions/propertyActions';
import IncomeDetails from '../../components/tb/IncomeDetails';

/**
 * ChecklistIncomeDetailsContainer container component
 * @extends {React.Component}
 */
export class ChecklistIncomeDetailsContainer extends React.Component {
  /**
   * Creates a new ChecklistIncomeDetailsContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);

    this.state = { tbMode: 1 };
  }

  componentDidMount() {
    if (this.props.periodId && this.props.isSectionVisible) {
      if (
        !this.props.isExternal ||
        this.props.authenticationScope === 'external'
      ) {
        this.props.incomeActions.fetchIncomeTestSummary(this.props.periodId);
        this.props.incomeActions.fetchPropertyDetails(this.props.periodId);
        this.props.incomeActions.fetchPropertyItsi(this.props.periodId);
        this.props.propertyActions.fetchPropertiesByPeriod(this.props.periodId);
      }

      if (
        this.props.isExternal &&
        this.props.checklistId &&
        this.props.isArqc
      ) {
        this.props.incomeActions.fetchExternalIncomeSummaryByChecklistId(
          this.props.periodId,
          this.props.checklistId,
          'ARQC'
        );
        this.props.incomeActions.fetchExternalPropertyDetailsByChecklistId(
          this.props.periodId,
          this.props.checklistId,
          'ARQC'
        );
        this.props.incomeActions.fetchExternalPropertyItsiByChecklistId(
          this.props.periodId,
          this.props.checklistId,
          'ARQC'
        );
        this.props.propertyActions.fetchExternalPropertiesByPeriod(
          this.props.periodId,
          this.props.checklistId,
          'ARQC'
        );
      }
    }
  }

  /**
   * Render a React element
   * @returns {Object} A reference to the component
   */
  render() {
    if (!this.props.incomeDetails) {
      return null;
    }

    return (
      <div>
        <IncomeDetails
          incomeDetails={this.props.incomeDetails}
          propertyDetails={this.props.propertyDetails}
          propertyItsi={this.props.propertyItsi}
          properties={this.props.properties}
        />
      </div>
    );
  }
}

ChecklistIncomeDetailsContainer.propTypes = {
  incomeActions: PropTypes.object,
  propertyActions: PropTypes.object,
  periodId: PropTypes.number,
  incomeDetails: PropTypes.array.isRequired,
  propertyDetails: PropTypes.object,
  propertyItsi: PropTypes.object,
  properties: PropTypes.array,
  isSectionVisible: PropTypes.bool,
  checklistId: PropTypes.string,
  isExternal: PropTypes.bool,
  isArqc: PropTypes.bool,
  authenticationScope: PropTypes.string,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @param {Object} ownProps The properties of the component
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  return {
    periodId: ownProps.periodId,
    checklistId: ownProps.checklistId,
    isSectionVisible: ownProps.isSectionVisible,
    isExternal: ownProps.isExternal,
    incomeDetails: state.incomeDetails,
    propertyDetails: state.propertyDetails,
    propertyItsi: state.propertyItsi,
    properties: state.properties,
    isArqc: ownProps.isArqc,
    authenticationScope: state.authenticationScope,
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    incomeActions: bindActionCreators(incomeActions, dispatch),
    propertyActions: bindActionCreators(propertyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChecklistIncomeDetailsContainer);
